
















































import {
    Advisor,
    BaseView,
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent,
    Prop,
    SectionType,
    VueComponent,
} from "@zoovu/runner-browser-api";
import {PdfConfiguration} from "../configuration";

@Component({})
export default class AdvisorSectionView extends BaseView {
    @InjectComponent("PagesNavigationView")
    pagesNavigationView: VueComponent;

    @InjectComponent("StartOverButtonView")
    startOverButtonView: VueComponent;

    @InjectComponent("PageSelectorView")
    pageSelectorView: VueComponent;

    @InjectComponent("PdfDownloadButtonView")
    pdfDownloadButtonView: VueComponent;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(PdfConfiguration)
    pdfConfiguration: PdfConfiguration;

    @Prop()
    advisor: Advisor;

    @Prop()
    sectionType: SectionType;

    @Prop({default: true})
    showNavigationBelowMainSection: boolean;

    @Prop({default: true})
    showPageSelectorBetweenNavigationButtons: boolean;

    @Prop({default: false})
    showPageSelectorAboveMainSection: boolean;

    @Prop()
    rootElementClass: string;

    get isActiveSection(): boolean {
        return this.advisor.advisorNavigation.currentSection.type === this.sectionType;
    }

    get classList(): ReadonlyArray<string | Record<string, unknown>> {
        return [
            this.rootElementClass,
            this.componentStyle.container,
            `section-type--${this.sectionType.toLowerCase()}`
        ]
    }

    get isPdfButtonVisible(): boolean {
        return this.pdfConfiguration && this.pdfConfiguration.enabled && this.isResultPage;
    }

    get isQuestionnaire(): boolean {
        return this.advisor.advisorNavigation.currentSection.type === SectionType.QUESTIONNAIRE;
    }

    get isResultPage(): boolean {
        return this.advisor.advisorNavigation.currentSection.type === SectionType.RESULTS_PAGE;
    }

    get isNotFirstStep(): boolean {
        return this.advisor.flowStepsNavigation.currentStepIndex > 0;
    }
}
